import { render } from "./TplanNew.vue?vue&type=template&id=50db7ed6"
import script from "./TplanNew.vue?vue&type=script&lang=js"
export * from "./TplanNew.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__